
import { Facebook, Instagram, Twitter, Linkedin, Youtube, Rss, Globe } from 'lucide-react';

interface ProfileIconProps {
  platform: string;
  size?: "sm" | "md" | "lg";
}

const ProfileIcon = ({ platform, size = "md" }: ProfileIconProps) => {
  // Déterminer les classes en fonction de la taille
  const getSizeClasses = () => {
    switch (size) {
      case "sm": return "h-4 w-4";
      case "lg": return "h-6 w-6";
      default: return "h-5 w-5";
    }
  };

  const sizeClasses = getSizeClasses();

  switch (platform.toLowerCase()) {
    case 'facebook':
      return <Facebook className={`${sizeClasses} text-blue-600`} />;
    case 'instagram':
      return <Instagram className={`${sizeClasses} text-pink-600`} />;
    case 'twitter':
    case 'x':
      return <Twitter className={`${sizeClasses} text-slate-800`} />;
    case 'linkedin':
      return <Linkedin className={`${sizeClasses} text-blue-700`} />;
    case 'youtube':
      return <Youtube className={`${sizeClasses} text-red-600`} />;
    case 'tiktok':
      return (
        <svg className={sizeClasses} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
        </svg>
      );
    case 'pinterest':
      return (
        <svg className={sizeClasses} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.477 2 2 6.477 2 12c0 4.237 2.636 7.855 6.356 9.312-.088-.791-.167-2.005.035-2.868.182-.78 1.172-4.97 1.172-4.97s-.299-.6-.299-1.486c0-1.39.806-2.428 1.81-2.428.852 0 1.264.64 1.264 1.408 0 .858-.546 2.14-.828 3.33-.236.995.5 1.807 1.48 1.807 1.778 0 3.144-1.874 3.144-4.58 0-2.393-1.72-4.068-4.177-4.068-2.845 0-4.515 2.135-4.515 4.34 0 .859.331 1.781.744 2.281a.3.3 0 01.069.288l-.278 1.133c-.044.183-.145.223-.335.134-1.249-.581-2.03-2.407-2.03-3.874 0-3.154 2.292-6.052 6.608-6.052 3.469 0 6.165 2.473 6.165 5.776 0 3.447-2.173 6.22-5.19 6.22-1.013 0-1.965-.525-2.291-1.148l-.623 2.378c-.226.869-.835 1.958-1.244 2.621.937.29 1.931.446 2.962.446 5.523 0 10-4.477 10-10S17.523 2 12 2z"/>
        </svg>
      );
    case 'threads':
      return (
        <div className="flex items-center justify-center w-full h-full rounded-full bg-black text-white font-bold">
          @
        </div>
      );
    case 'meta':
      return <Facebook className={`${sizeClasses} text-blue-600`} />;
    case 'google-business':
      return <Globe className={`${sizeClasses} text-blue-500`} />;
    case 'rss':
      return <Rss className={`${sizeClasses} text-orange-500`} />;
    default:
      return (
        <div className="flex items-center justify-center w-full h-full rounded-full bg-blue-100 text-blue-600 font-medium">
          {platform.charAt(0).toUpperCase()}
        </div>
      );
  }
};

export default ProfileIcon;
